import React from "react";
import classNames from "../classNames";
import Spinner from "../Spinner";

const defaultProps = {
    className: "bg-white", icon: "bi bi-people", value: "0", label: "TOTAL", labelAction: "VIEW",
};

function DashboardCard({className, icon, label, value, labelAction, onClick,loading}) {
    const [count, setCount] = React.useState(0);
    React.useEffect(() => {
        let start = 0;
        const end = parseInt(value);
        const duration = 1000; // Animation duration in milliseconds
        const increment = Math.ceil(end / (duration / 10));
        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(start);
            }
        }, 10);
        return () => {
            clearInterval(timer); // Clean up the timer when component unmounts
        };
    }, [value]);

    return (
        <div className={classNames(className, "shadow-sm bg-white p-3 p-lg-4 rounded")}>
            <div className="d-flex justify-content-between">
                <span className="fs-2">
                  <i className={icon}></i>
                </span>
                <h3>{count.toLocaleString()}</h3>
            </div>
            <div className="text-end">
                <p className="m-0 text-truncate">{label}</p>
            </div>
            <hr/>
            {
                loading ? (
                    <Spinner/>
                    ):(
                    <button onClick={onClick}
                            className="btn btn-link p-0 w-100 d-flex justify-content-between text-uppercase text-truncate">
                        {labelAction}
                        <i className="bi bi-arrow-right"></i>
                    </button>
                )
            }

        </div>
    );
}

DashboardCard.defaultProps = defaultProps;
export default DashboardCard;
